Number.prototype.isCloseTo = function (other, precision = 14) {
    const delta = Number(`1e-${precision}`);
    return this > (other - delta) && this < (other + delta);
    //return this.toFixed(precision) === other.toFixed(precision);  
};
Number.prototype.roundoff = function (precision = 14) {
    return parseFloat(this.toFixed(precision));
};
Number.prototype.clamp = function (min, max) {
    let value = this;
    if (min != null && !isNaN(min)) {
        value = Math.max(value, min);
    }
    if (max != null && !isNaN(max)) {
        value = Math.min(value, max);
    }
    return value;
};
Number.prototype.toBase62 = function () {
    var alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var temp = this;
    var sb = '';
    while (temp != 0) {
        var mod = temp % 62;
        sb = alphabet.charAt(mod) + sb;
        temp = Math.floor(temp / 62);
    }
    return sb;
};
Number.prototype.toBase36 = function () {
    return this.toString(36);
};
export {};
